<tax-page-header
  titleText="organization.title"
  [dropdownItems]="dropdownItems$ | async"
></tax-page-header>

<div
  data-qa-block="organization-info"
  class="ui-kit-content-container"
  *ngIf="organization$ | async as organization"
>
  <tax-info-legal *ngIf="organisationType.isLegal" [organization]="organization"></tax-info-legal>
  <tax-info-individual
    *ngIf="organisationType.isIndividual"
    [organization]="organization"
  ></tax-info-individual>
</div>
